<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 10:34:58
-->
<script setup>
    import {ref,toRefs,watch} from 'vue'
    import zhCN from 'ant-design-vue/es/locale/zh_CN'
    import en from 'ant-design-vue/es/locale/en_GB'
    import dayjs from 'dayjs'
    import 'dayjs/locale/zh-cn'
    import 'dayjs/locale/en-gb'
    import { globalView } from '@/store/global.js';
    import { ConfigProvider } from 'ant-design-vue';

    dayjs.locale('zh-cn')
    dayjs.locale('en-gb')

    const globalViewStore = globalView()
    const {lang} = toRefs(globalViewStore)

    ConfigProvider.config({
      theme: {
        primaryColor: '#1226aa',
      },
    });

    let locale = ''
    if(localStorage.getItem('lang')){
      let cache_lang = localStorage.getItem('lang')
      locale = cache_lang == 'zh'? ref(zhCN) :  ref(en)
    }else{
      locale = ref(zhCN)
    }

    watch(lang,(newVal,oldVal)=>{
      locale = newVal == 'zh'? ref(zhCN) :  ref(en)
      location.reload()
    })
    
</script>

<template>
  <a-config-provider :locale="locale">
    <router-view></router-view>
  </a-config-provider>
  
</template>

<style scoped>

</style>
